import React from 'react'
import { useI18n, LANGS } from '../lib/i18n'
import styles from './LanguageSwitcher.module.css'

// Compact segmented control for the navbar. Every supported language is
// visible at once — no blind EN↔HI toggle, no dropdown to open.
const LanguageSwitcher = ({ variant = 'desktop' }) => {
  const { lang, setLang } = useI18n()

  return (
    <div
      className={`${styles.root} ${variant === 'mobile' ? styles.rootMobile : ''}`}
      role="group"
      aria-label="Change language"
    >
      {LANGS.map((l) => {
        const on = l.code === lang
        return (
          <button
            key={l.code}
            type="button"
            lang={l.code}
            title={l.label}
            aria-pressed={on}
            className={`${styles.seg} ${on ? styles.segOn : ''}`}
            onClick={() => setLang(l.code)}
          >
            <span className={styles.segFlag} aria-hidden="true">{l.flag}</span>
            {l.code.toUpperCase()}
          </button>
        )
      })}
    </div>
  )
}

export default LanguageSwitcher
